import React from 'react';
import styled from 'styled-components';

const Title = styled.h3`
  /* font-family: ProximaNova; */
  display: inline-block;
  margin-top: 12px;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 12px;
`;

export default React.memo(({ title }) => {
  return <Title>{title}</Title>;
});
